import pkg from "../package.json";

const availableLanguages = ["en", "es", "fr", "hi"];

// for all options read: https://www.i18next.com/overview/configuration-options
export const i18nOptions = {
  fallbackLng: "en",
  // debug: true,
  supportedLangs: availableLanguages,
  // React escapes rendered text; i18next escaping on top shows `&amp;`. Any
  // raw-HTML sink (e.g. GetInfoTool's setHTML) must escape for itself.
  interpolation: { escapeValue: false },
  react: {
    useSuspense: true,
  },
  // prevent cache on version updates by tagging language files
  backend: {
    loadPath: `/locales/{{lng}}/{{ns}}.json?${pkg?.version}`,
  },
};
